// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.uWQJ0TcbYRTG5BNEqzUu {
  display: flex;
  height: 100%;
  width: 100%;
  max-width: var(--content-column);
  margin: 0 auto;
}

.wJjO7zqZFZk3sESG55IE {
  flex: 0 0 29.6875rem;
  padding-top: 3rem;
  padding-bottom: 0.9375rem;
  padding-left: 1.5rem;
  background-color: var(--grey-100);
}

.yIlIqpbCEZ_60I8HLOeC {
  width: 2rem;
  height: 2rem;
}

.au9UMZYfCt3SzE6HEKm4 {
  margin-left: 1rem;
}

.nGq1FICRKDYmdPNv3Ns_ {
  display: flex;
  align-items: center;
  height: 4rem;
  padding-left: 2.5rem;
  border-top-left-radius: 4rem;
  border-bottom-left-radius: 4rem;
  cursor: pointer
}

.nGq1FICRKDYmdPNv3Ns_.iJ0VDwq_Pjj_yBG_YcDW {
    background-color: var(--white)
  }

.nGq1FICRKDYmdPNv3Ns_.iJ0VDwq_Pjj_yBG_YcDW .au9UMZYfCt3SzE6HEKm4 {
      color: var(--category-highlight-color);
    }

.wtCTkGOxBcW8jF_obVnI {
  flex: 1 1 auto;
  overflow: auto;
}

.cT6LkitS6LWQeMPZqx_8 {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  max-width: 39.75rem;
  margin: 0 auto;
  padding: 3.125rem 0 5.25rem;
}

.pzPUEPAH5fPgjxexmlWV {
  flex: 0 1 46%;
  margin-bottom: 2.5rem;
}

.piLdodz8FYSNmOmTbBZ0 {
  font-size: 0.875rem;
  line-height: 1.5rem;
  justify-content: flex-start;
}

.byVrDBmaqlqrxgpuXZZr {
  flex: 0 0 100%;
  margin-bottom: 5.5rem;
}

@media only screen and
  (min-width: 1024px) and
  (max-width: 1279px) {
  .wJjO7zqZFZk3sESG55IE {
    flex: 0 0 21rem;
  }

  .cT6LkitS6LWQeMPZqx_8 {
    max-width: 38rem;
  }
}

@media only screen and
  (min-width: 640px) and
  (max-width: 1023px) {
  .uWQJ0TcbYRTG5BNEqzUu {
    height: auto;
  }

  .nGq1FICRKDYmdPNv3Ns_ {
    padding-left: 0
  }

    .nGq1FICRKDYmdPNv3Ns_.iJ0VDwq_Pjj_yBG_YcDW {
      background-color: transparent;
      cursor: default;
    }

  .yIlIqpbCEZ_60I8HLOeC {
    width: 1.5rem;
    height: 1.5rem;
  }

  .wJjO7zqZFZk3sESG55IE {
    overflow-y: auto;
    flex: 0 0 100%;
    padding-left: 2rem;
    padding-bottom: 1.25rem;
  }
}

@media only screen and
  (max-width: 639px) {
  .uWQJ0TcbYRTG5BNEqzUu {
    height: auto;
  }

  .nGq1FICRKDYmdPNv3Ns_ {
    padding-left: 0;
  }

  .yIlIqpbCEZ_60I8HLOeC {
    width: 1.5rem;
    height: 1.5rem;
  }

  .wJjO7zqZFZk3sESG55IE {
    overflow-y: auto;
    flex: 0 0 100%;
    padding-bottom: 1.25rem;
    padding-left: var(--content-padding-mobile);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/HeaderMenuGiftCardsTabs/HeaderMenuGiftCardsTabs.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,YAAY;EACZ,WAAW;EACX,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,oBAAe;EACf,iBAAiB;EACjB,yBAAoB;EACpB,oBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,oBAAkB;EAClB,4BAA4B;EAC5B,+BAA+B;EAC/B;AASF;;AAPE;IACE;EAKF;;AAHE;MACE,sCAAsC;IACxC;;AAIJ;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,mBAAgB;EAChB,cAAc;EACd,2BAAoB;AACtB;;AAEA;EACE,aAAa;EACb,qBAAmB;AACrB;;AAEA;EACE,mBAAe;EACf,mBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,qBAAmB;AACrB;;AAEA;;;EACE;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;;;EACE;IACE,YAAY;EACd;;EAEA;IACE;EAMF;;IAJE;MACE,6BAA6B;MAC7B,eAAe;IACjB;;EAGF;IACE,aAAW;IACX,cAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,uBAAoB;EACtB;AACF;;AAEA;;EACE;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAW;IACX,cAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,cAAc;IACd,uBAAoB;IACpB,2CAA2C;EAC7C;AACF","sourcesContent":[".container {\n  display: flex;\n  height: 100%;\n  width: 100%;\n  max-width: var(--content-column);\n  margin: 0 auto;\n}\n\n.itemsContainer {\n  flex: 0 0 475px;\n  padding-top: 48px;\n  padding-bottom: 15px;\n  padding-left: 24px;\n  background-color: var(--grey-100);\n}\n\n.menuItemIcon {\n  width: 32px;\n  height: 32px;\n}\n\n.menuItemTitle {\n  margin-left: 16px;\n}\n\n.menuItem {\n  display: flex;\n  align-items: center;\n  height: 64px;\n  padding-left: 40px;\n  border-top-left-radius: 64px;\n  border-bottom-left-radius: 64px;\n  cursor: pointer;\n\n  &.active {\n    background-color: var(--white);\n\n    & .menuItemTitle {\n      color: var(--category-highlight-color);\n    }\n  }\n}\n\n.contentContainer {\n  flex: 1 1 auto;\n  overflow: auto;\n}\n\n.contentWrapper {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  max-width: 636px;\n  margin: 0 auto;\n  padding: 50px 0 84px;\n}\n\n.contentItem {\n  flex: 0 1 46%;\n  margin-bottom: 40px;\n}\n\n.viewAllCategoriesBtn {\n  font-size: 14px;\n  line-height: 24px;\n  justify-content: flex-start;\n}\n\n.viewAllCouponsContainer {\n  flex: 0 0 100%;\n  margin-bottom: 88px;\n}\n\n@media (--desktop-small) {\n  .itemsContainer {\n    flex: 0 0 336px;\n  }\n\n  .contentWrapper {\n    max-width: 608px;\n  }\n}\n\n@media (--tablet) {\n  .container {\n    height: auto;\n  }\n\n  .menuItem {\n    padding-left: 0;\n\n    &.active {\n      background-color: transparent;\n      cursor: default;\n    }\n  }\n\n  .menuItemIcon {\n    width: 24px;\n    height: 24px;\n  }\n\n  .itemsContainer {\n    overflow-y: auto;\n    flex: 0 0 100%;\n    padding-left: 32px;\n    padding-bottom: 20px;\n  }\n}\n\n@media (--mobile) {\n  .container {\n    height: auto;\n  }\n\n  .menuItem {\n    padding-left: 0;\n  }\n\n  .menuItemIcon {\n    width: 24px;\n    height: 24px;\n  }\n\n  .itemsContainer {\n    overflow-y: auto;\n    flex: 0 0 100%;\n    padding-bottom: 20px;\n    padding-left: var(--content-padding-mobile);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `uWQJ0TcbYRTG5BNEqzUu`,
	"itemsContainer": `wJjO7zqZFZk3sESG55IE`,
	"menuItemIcon": `yIlIqpbCEZ_60I8HLOeC`,
	"menuItemTitle": `au9UMZYfCt3SzE6HEKm4`,
	"menuItem": `nGq1FICRKDYmdPNv3Ns_`,
	"active": `iJ0VDwq_Pjj_yBG_YcDW`,
	"contentContainer": `wtCTkGOxBcW8jF_obVnI`,
	"contentWrapper": `cT6LkitS6LWQeMPZqx_8`,
	"contentItem": `pzPUEPAH5fPgjxexmlWV`,
	"viewAllCategoriesBtn": `piLdodz8FYSNmOmTbBZ0`,
	"viewAllCouponsContainer": `byVrDBmaqlqrxgpuXZZr`
};
export default ___CSS_LOADER_EXPORT___;
